'use client'

import Script from 'next/script'
import React from 'react'

export const FacebookSDK: React.FC = () => {
  const initFacebookSDK = () => {
    if (window.FB) {
      window.FB.init({
        appId: '400969073655308',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v11.0',
      })
    }
  }

  return <Script src="https://connect.facebook.net/en_US/sdk.js" crossOrigin="anonymous" onLoad={initFacebookSDK} />
}

export default FacebookSDK
